import _defineProperty2 from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "./index.css";
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { Container } from '@design-system/container';
import { SearchBlock } from '@design-system/search-block';
import { Section } from '@design-system/section';
import classNames from 'classnames';
import React, { useState, useEffect, useCallback, forwardRef, useRef } from 'react';
import { Link } from '@design-system/link';
import { Button } from '@design-system/button';
import FocusTrap from 'focus-trap-react';
import { ExtendableImage } from '@design-system/extendable-image';
import { Tooltip } from '@design-system/tooltip';
import { isBrowser } from '@phx-husky/browser-helpers';
import { useScreenRecognition } from '@phx-husky/use-screen-recognition';
import { Icon } from '@design-system/icon';
var BurgerCloser = function BurgerCloser(_ref2) {
  var burgerCloseIcon = _ref2.burgerCloseIcon,
    burgerCloseLabel = _ref2.burgerCloseLabel,
    isJS = _ref2.isJS;
  return !isJS ? jsx(Link, Object.assign({
    className: "cds-global-header__burger-closer",
    variant: "subtle-icon",
    href: "#close-menu",
    size: "large",
    iconSuffix: {
      props: burgerCloseIcon
    }
  }, {
    children: burgerCloseLabel
  })) : null;
};
var BurgerOpener = function BurgerOpener(_ref3) {
  var burgerCloseIcon = _ref3.burgerCloseIcon,
    burgerOpenLabel = _ref3.burgerOpenLabel,
    burgerOpenIcon = _ref3.burgerOpenIcon,
    burgerToggleLabel = _ref3.burgerToggleLabel,
    handleBurgerClick = _ref3.handleBurgerClick,
    isOpen = _ref3.isOpen,
    isJS = _ref3.isJS,
    burgerBtnRef = _ref3.burgerBtnRef,
    isMobileView = _ref3.isMobileView;
  if (isJS && isMobileView) return jsx(Button, Object.assign({
    ref: burgerBtnRef,
    variant: "subtle-icon",
    className: "cds-navigation-mobile__burger",
    size: "large",
    iconSuffix: {
      props: isOpen ? burgerCloseIcon : burgerOpenIcon
    },
    onClick: handleBurgerClick,
    "aria-expanded": !!isOpen
  }, {
    children: burgerToggleLabel
  }));
  if (isJS && !isMobileView) {
    return null;
  }
  return jsx(Link, Object.assign({
    className: "cds-global-header__burger-opener",
    variant: "subtle-icon",
    href: "#open-menu",
    size: "large",
    iconSuffix: {
      props: burgerOpenIcon
    }
  }, {
    children: burgerOpenLabel
  }));
};
var CartIcon = function CartIcon(_ref4) {
  var ariaLabel = _ref4.ariaLabel,
    href = _ref4.href,
    _ref4$LinkComponent = _ref4.LinkComponent,
    LinkComponent = _ref4$LinkComponent === void 0 ? Link : _ref4$LinkComponent,
    itemsQuantity = _ref4.itemsQuantity;
  return jsx(LinkComponent, Object.assign({
    className: classNames('cds-shopping-cart-icon', {
      'cds-shopping-cart-icon--no-items': itemsQuantity === 0
    }),
    variant: "subtle-icon",
    size: "small",
    href: href,
    iconSuffix: {
      props: {
        icon: 'shoppingCart'
      }
    },
    "aria-label": ariaLabel
  }, {
    children: itemsQuantity
  }));
};
var FocusTrapWrapper = function FocusTrapWrapper(_ref5) {
  var isOpen = _ref5.isOpen,
    isJS = _ref5.isJS,
    isMobileView = _ref5.isMobileView,
    children = _ref5.children;
  var Wrapper = isOpen && isJS && isMobileView ? FocusTrap : React.Fragment;
  return jsx(Wrapper, {
    children: children
  });
};
var Logo = function Logo(_ref6) {
  var className = _ref6.className,
    image = _ref6.image,
    link = _ref6.link,
    onClick = _ref6.onClick;
  var LinkComponent = (link === null || link === void 0 ? void 0 : link.component) || Link;
  var linkProps = link === null || link === void 0 ? void 0 : link.props;
  return jsx("div", Object.assign({
    className: classNames('cds-logo', className)
  }, {
    children: link && linkProps ? jsx(LinkComponent, Object.assign({
      onClick: onClick
    }, linkProps, {
      className: "cds-logo__link",
      variant: "wrapper",
      tabIndex: -1,
      "aria-hidden": "true"
    }, {
      children: jsx(ExtendableImage, Object.assign({}, image))
    })) : jsx(ExtendableImage, Object.assign({}, image))
  }));
};
var itemClassName = 'cds-global-header__navigation-item';
var hiddenItemClassName = 'cds-global-header__navigation-item--hidden';
var moreClassName = 'cds-global-header__more-item';
var languageSwitchClassName = 'cds-global-header__lang-switch';
var logoClassName = 'cds-global-header__navigation-logo';
var searchClassName = 'cds-global-header__navigation-search';
var cartIconClassName = 'cds-global-header__cart-icon';
var profileClassName = 'cds-global-header__navigation-profile';
var navItemQuerySelector = 'li.cds-global-header__navigation-item';
var blurDelay = 100;
var keySpacebar = 'Spacebar';
var keyEnter = 'Enter';
var useBrowserScreen = function useBrowserScreen() {
  var _useScreenRecognition = useScreenRecognition(),
    isMobile = _useScreenRecognition.isMobile,
    isTablet = _useScreenRecognition.isTablet,
    isDesktop = _useScreenRecognition.isDesktop;
  var isMobileView = isBrowser() && isMobile;
  var isTabletView = isBrowser() && isTablet;
  var isDesktopView = isBrowser() && isDesktop;
  return {
    isMobileView: isMobileView,
    isTabletView: isTabletView,
    isDesktopView: isDesktopView
  };
};
var useJS = function useJS() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isJS = _useState2[0],
    setIsJS = _useState2[1];
  useEffect(function () {
    setIsJS(!!typeof window);
  }, []);
  return [isJS];
};
var useDebounceFunc = function useDebounceFunc(func) {
  var milliseconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 400;
  var time = milliseconds;
  var timer;
  return function (event) {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(func, time, event);
  };
};
var useNavigationResize = function useNavigationResize(_ref7) {
  var listRef = _ref7.listRef,
    navRef = _ref7.navRef,
    navigationData = _ref7.navigationData;
  var _useBrowserScreen = useBrowserScreen(),
    isMobileView = _useBrowserScreen.isMobileView;
  var _useState3 = useState(navigationData),
    _useState4 = _slicedToArray(_useState3, 2),
    visibleItems = _useState4[0],
    setVisibleItems = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    hiddenItems = _useState6[0],
    setHiddenItems = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    widthData = _useState8[0],
    setWidthData = _useState8[1];
  var _useState9 = useState(0),
    _useState10 = _slicedToArray(_useState9, 2),
    logoWidth = _useState10[0],
    setLogoWidth = _useState10[1];
  var _useState11 = useState(0),
    _useState12 = _slicedToArray(_useState11, 2),
    searchWidth = _useState12[0],
    setSearchWidth = _useState12[1];
  var _useState13 = useState(0),
    _useState14 = _slicedToArray(_useState13, 2),
    cartIconWidth = _useState14[0],
    setCartIconWidth = _useState14[1];
  var _useState15 = useState(0),
    _useState16 = _slicedToArray(_useState15, 2),
    profileWidth = _useState16[0],
    setProfileWidth = _useState16[1];
  var handleResize = useCallback(function () {
    if (widthData && navRef.current) {
      var navElWidth = navRef.current.offsetWidth;
      var navItems = widthData.navItems,
        langSwitchBtnWidth = widthData.langSwitchBtnWidth;
      var moreItemElement = navRef.current.getElementsByClassName(moreClassName)[0];
      var moreBtnWidth = (moreItemElement === null || moreItemElement === void 0 ? void 0 : moreItemElement.clientWidth) || 0;
      var sum = langSwitchBtnWidth + moreBtnWidth + logoWidth + searchWidth + cartIconWidth + profileWidth;
      var visibleArr = [];
      var hiddenArr = [];
      navItems.forEach(function (_, index) {
        var navItem = document.querySelectorAll(navItemQuerySelector)[index];
        var navItemWidth = navItem && navItem.getBoundingClientRect().width;
        sum += navItemWidth;
        if (navElWidth >= sum) {
          visibleArr.push(navigationData[index]);
        } else {
          hiddenArr.push(navigationData[index]);
        }
      });
      setVisibleItems(visibleArr);
      setHiddenItems(hiddenArr);
    }
  }, [searchWidth, logoWidth, navRef, navigationData, widthData, cartIconWidth, profileWidth]);
  useEffect(function () {
    if ((listRef === null || listRef === void 0 ? void 0 : listRef.current) && !isMobileView) {
      var widthDataObj = {
        navItems: [],
        langSwitchBtnWidth: 0
      };
      var children = Array.from(listRef.current.children);
      var visibleItemsCount = children.filter(function (_ref8) {
        var className = _ref8.className;
        return className.includes(itemClassName) && !className.includes(moreClassName);
      }).length;
      if (visibleItemsCount !== navigationData.length) return;
      children.forEach(function (item) {
        if (item.className.includes(itemClassName) && !item.className.includes(moreClassName)) {
          widthDataObj.navItems.push({
            width: item.clientWidth,
            item: item
          });
        }
        if (item.className.includes(languageSwitchClassName)) {
          widthDataObj.langSwitchBtnWidth = item.clientWidth;
        }
      });
      setWidthData(widthDataObj);
    }
  }, [listRef, navigationData, isMobileView]);
  useEffect(function () {
    handleResize();
  }, [handleResize, isMobileView]);
  var debouncedHandleResize = useDebounceFunc(handleResize, 400);
  useEffect(function () {
    if (!isMobileView) {
      window.addEventListener('resize', debouncedHandleResize);
    } else {
      window.removeEventListener('resize', debouncedHandleResize);
    }
    return function () {
      window.removeEventListener('resize', debouncedHandleResize);
    };
  }, [debouncedHandleResize, isMobileView]);
  useEffect(function () {
    var RO;
    if (listRef.current && !isMobileView) {
      RO = new ResizeObserver(function (entries) {
        var targetArr = Array.from(entries[0].target.children);
        var itemsWithoutLogo = targetArr.filter(function (el) {
          return !el.className.includes(logoClassName);
        });
        var logo = targetArr.find(function (el) {
          return el.className.includes(logoClassName);
        });
        var search = targetArr.find(function (el) {
          return el.className.includes(searchClassName);
        });
        var cartIcon = targetArr.find(function (el) {
          return el.className.includes(cartIconClassName);
        });
        var profile = targetArr.find(function (el) {
          return el.className.includes(profileClassName);
        });
        itemsWithoutLogo.forEach(function (menuElement) {
          return menuElement.classList.add(hiddenItemClassName);
        });
        if (logo === null || logo === void 0 ? void 0 : logo.clientWidth) {
          var logoComputedStyle = getComputedStyle(logo);
          var logoPaddingRight = parseFloat(logoComputedStyle.paddingRight);
          var navElComputedStyle = getComputedStyle(itemsWithoutLogo[0]);
          var navElPaddingLeft = parseFloat(navElComputedStyle.paddingLeft);
          setLogoWidth(logo.clientWidth + navElPaddingLeft + logoPaddingRight);
        }
        if (search === null || search === void 0 ? void 0 : search.clientWidth) {
          setSearchWidth(search.clientWidth);
        }
        if (cartIcon === null || cartIcon === void 0 ? void 0 : cartIcon.clientWidth) {
          setCartIconWidth(cartIcon.clientWidth);
        }
        if (profile === null || profile === void 0 ? void 0 : profile.clientWidth) {
          setProfileWidth(profile.clientWidth);
        }
        itemsWithoutLogo.forEach(function (menuElement) {
          return menuElement.classList.remove(hiddenItemClassName);
        });
        handleResize();
      });
      RO.observe(listRef.current);
      return function () {
        RO.disconnect();
      };
    }
    if (listRef.current && isMobileView && RO) {
      RO.disconnect();
    }
    return undefined;
  }, [listRef, isMobileView, handleResize]);
  return {
    visibleItems: visibleItems,
    hiddenItems: hiddenItems
  };
};
var shouldBeRendered = function shouldBeRendered(data, conditions) {
  var operator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'or';
  if (!data) return false;
  if (operator === 'or') {
    return conditions.some(function (c) {
      return c;
    });
  }
  if (operator === 'and') {
    return conditions.every(function (c) {
      return c;
    });
  }
  return false;
};
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function __rest$1(s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
var getClassName = function getClassName(_ref) {
  var _classNames;
  var align = _ref.align,
    variant = _ref.variant,
    wrapping = _ref.wrapping,
    className = _ref.className,
    size = _ref.size,
    weight = _ref.weight;
  var isBodyOrHeadlineOrDetail = variant === 'body' || variant === 'headline' || variant === 'detail';
  return classNames('cds-typography', className, (_classNames = {}, _defineProperty(_classNames, "cds-typography--align-".concat(align), align), _defineProperty(_classNames, "cds-typography--variant-".concat(variant), variant), _defineProperty(_classNames, "cds-typography--variant-".concat(variant, "-").concat(size), isBodyOrHeadlineOrDetail && size), _defineProperty(_classNames, "cds-typography--wrapping-".concat(wrapping), wrapping), _defineProperty(_classNames, "cds-typography--weight-".concat(weight), isBodyOrHeadlineOrDetail && weight), _classNames));
};
var unwrapFirstTag = function unwrapFirstTag(typographyTag, typographyVariant, typographyContent) {
  var openTagRegExp = /^<\/?[^>]+(>|$)/g;
  var closeTagRegExp = /<\/[^>]+(>$)/g;
  return typographyVariant !== 'rte' && typographyTag !== 'div' ? typographyContent.toString().replace(openTagRegExp, '').replace(closeTagRegExp, '') : typographyContent;
};
var Typography = /*#__PURE__*/forwardRef(function (_a, ref) {
  var content = _a.content,
    _a$tag = _a.tag,
    tag = _a$tag === void 0 ? 'div' : _a$tag,
    variant = _a.variant,
    align = _a.align,
    className = _a.className,
    _a$size = _a.size,
    size = _a$size === void 0 ? 'm' : _a$size,
    _a$weight = _a.weight,
    weight = _a$weight === void 0 ? 'regular' : _a$weight,
    _a$wrapping = _a.wrapping,
    wrapping = _a$wrapping === void 0 ? 'break-word' : _a$wrapping,
    link = _a.link,
    htmlProperties = __rest(_a, ["content", "tag", "variant", "align", "className", "size", "weight", "wrapping", "link"]);
  var LinkElement = (link === null || link === void 0 ? void 0 : link.component) || Link;
  var typographyClassName = getClassName({
    align: align,
    variant: variant,
    wrapping: wrapping,
    className: className,
    size: size,
    weight: weight
  });
  var Tag = tag && variant !== 'rte' ? tag : 'div';
  var html = unwrapFirstTag(tag, variant, content);
  return link ? jsx(Tag, Object.assign({
    className: typographyClassName,
    ref: ref
  }, htmlProperties, {
    children: jsx(LinkElement, Object.assign({}, link.props, {
      iconPrefix: undefined,
      iconSuffix: undefined
    }, {
      children: jsx("span", {
        dangerouslySetInnerHTML: {
          __html: html
        }
      })
    }))
  })) : jsx(Tag, Object.assign({
    className: typographyClassName,
    ref: ref,
    dangerouslySetInnerHTML: {
      __html: html
    }
  }, htmlProperties));
});
var useDropdown = function useDropdown() {
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    isOpen = _useState18[0],
    setIsOpen = _useState18[1];
  var timer = useRef();
  var _useBrowserScreen2 = useBrowserScreen(),
    isMobileView = _useBrowserScreen2.isMobileView;
  var handleShowMoreClick = function handleShowMoreClick(e) {
    e.preventDefault();
    setIsOpen(function (prevVal) {
      return !prevVal;
    });
  };
  var handleMenuItemClick = function handleMenuItemClick(e, hasSubitems, handleMobileNavigationItemClick) {
    if (!isMobileView) {
      return;
    }
    if (hasSubitems) {
      e.preventDefault();
      setIsOpen(function (prevVal) {
        return !prevVal;
      });
    } else {
      handleMobileNavigationItemClick();
    }
  };
  var handleMouseOver = function handleMouseOver(e) {
    e.preventDefault();
    if (!isOpen) {
      setIsOpen(true);
    }
  };
  var handleKeyPress = function handleKeyPress(e) {
    if (e.key === ' ' || e.key === keySpacebar || e.key === keyEnter) {
      e.preventDefault();
      setIsOpen(function (prevVal) {
        return !prevVal;
      });
    }
  };
  var handleDesktopBlur = function handleDesktopBlur() {
    if (isMobileView) {
      return;
    }
    timer.current = setTimeout(function () {
      setIsOpen(false);
    }, blurDelay);
  };
  var handleDesktopOutsideBlur = function handleDesktopOutsideBlur(e) {
    if (e.currentTarget.contains(e.relatedTarget) && !isMobileView) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    handleDesktopBlur();
  };
  var handleFocus = function handleFocus() {
    if (timer.current) clearTimeout(timer.current);
  };
  var handleEsc = function handleEsc(event) {
    if (event.key === 'Escape') {
      if (timer.current) clearTimeout(timer.current);
      setIsOpen(false);
    }
  };
  useEffect(function () {
    window.addEventListener('keyup', handleEsc);
    return function () {
      window.removeEventListener('keyup', handleEsc);
    };
  }, []);
  return {
    handleDesktopBlur: handleDesktopBlur,
    handleDesktopOutsideBlur: handleDesktopOutsideBlur,
    handleFocus: handleFocus,
    handleShowMoreClick: handleShowMoreClick,
    handleMenuItemClick: handleMenuItemClick,
    handleKeyPress: handleKeyPress,
    handleMouseOver: handleMouseOver,
    isOpen: isOpen
  };
};
var getLinkIcon = function getLinkIcon(openIcon, closeIcon, isOpen) {
  var shouldShow = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  return shouldShow && openIcon && closeIcon ? {
    props: isOpen ? closeIcon : openIcon
  } : undefined;
};
var getLinkSize = function getLinkSize(smallFactor) {
  return smallFactor ? 'large' : 'small';
};
var LanguageSwitch = function LanguageSwitch(_ref9) {
  var title = _ref9.title,
    ariaLabel = _ref9.ariaLabel,
    languageData = _ref9.languageData,
    _ref9$linkNavElement = _ref9.linkNavElement,
    LinkElement = _ref9$linkNavElement === void 0 ? Link : _ref9$linkNavElement,
    openIcon = _ref9.openIcon,
    closeIcon = _ref9.closeIcon,
    isMobileView = _ref9.isMobileView;
  var _useDropdown = useDropdown(),
    handleDesktopBlur = _useDropdown.handleDesktopBlur,
    handleDesktopOutsideBlur = _useDropdown.handleDesktopOutsideBlur,
    handleFocus = _useDropdown.handleFocus,
    handleShowMoreClick = _useDropdown.handleShowMoreClick,
    handleKeyPress = _useDropdown.handleKeyPress,
    isOpen = _useDropdown.isOpen,
    handleMouseOver = _useDropdown.handleMouseOver;
  var onMouseOverDesktop = !isMobileView ? handleMouseOver : undefined;
  return jsxs("li", Object.assign({
    className: classNames('cds-global-header__navigation-item', 'cds-global-header__navigation-item--has-children', languageSwitchClassName),
    onBlur: handleDesktopOutsideBlur,
    onMouseLeave: handleDesktopBlur
  }, {
    children: [jsx(Button, Object.assign({
      onKeyDown: handleKeyPress,
      onClick: handleShowMoreClick,
      onBlur: handleDesktopBlur,
      onMouseOver: onMouseOverDesktop,
      variant: "nav",
      size: getLinkSize(isMobileView),
      "aria-label": ariaLabel,
      "aria-expanded": isOpen,
      className: classNames('cds-global-header__lang-switch-btn', {
        active: isOpen
      }),
      iconPrefix: {
        props: {
          icon: 'translation',
          className: 'cds-global-header__lang-switch-icon'
        }
      },
      iconSuffix: getLinkIcon(openIcon, closeIcon, isOpen, !isMobileView)
    }, {
      children: title
    })), isMobileView ? jsx(Button, Object.assign({
      variant: "nav",
      onClick: handleShowMoreClick,
      onKeyDown: handleKeyPress,
      size: getLinkSize(isMobileView),
      className: "cds-global-header__navigation-arrow",
      "aria-expanded": isOpen,
      iconSuffix: getLinkIcon(openIcon, closeIcon, isOpen)
    }, {
      children: title
    })) : null, isOpen ? jsx("div", Object.assign({
      className: "cds-global-header__navigation-drop"
    }, {
      children: jsx("ul", Object.assign({
        className: "cds-global-header__lang-list"
      }, {
        children: languageData.map(function (_a) {
          var label = _a.label,
            href = _a.href,
            locale = _a.locale,
            translated = _a.translated,
            item = __rest$1(_a, ["label", "href", "locale", "translated"]);
          return jsx("li", {
            children: translated ? jsx(LinkElement, Object.assign({
              className: "cds-global-header__lang-link"
            }, item, {
              href: href,
              onClick: handleDesktopBlur,
              variant: "nav",
              size: getLinkSize(isMobileView),
              onFocus: handleFocus,
              onBlur: handleDesktopBlur
            }, {
              children: label
            })) : jsx(Typography, {
              className: "cds-global-header__lang-item",
              content: label,
              tag: "span",
              variant: "body"
            })
          }, locale);
        })
      }))
    })) : null]
  }));
};
var isActive = function isActive(activePath, linkHref, subLinks) {
  return subLinks.some(function (el) {
    return activePath.includes(el.href);
  }) || activePath === linkHref;
};
var SubNavigation = function SubNavigation(_ref10) {
  var className = _ref10.className,
    subItems = _ref10.subItems,
    _ref10$linkNavElement = _ref10.linkNavElement,
    LinkElement = _ref10$linkNavElement === void 0 ? Link : _ref10$linkNavElement,
    subMenuLabel = _ref10.subMenuLabel,
    activeUrlPath = _ref10.activeUrlPath,
    handleFocus = _ref10.handleFocus,
    handleBlur = _ref10.handleBlur,
    isMobileView = _ref10.isMobileView,
    href = _ref10.href,
    ariaLabel = _ref10.ariaLabel,
    handleMobileNavigationItemClick = _ref10.handleMobileNavigationItemClick,
    onClickSubnavItem = _ref10.onClickSubnavItem;
  var handleClick = function handleClick(subLabel) {
    if (onClickSubnavItem) onClickSubnavItem(subLabel);
    if (isMobileView) handleMobileNavigationItemClick();
  };
  return jsx("div", Object.assign({
    className: classNames('cds-global-header__navigation-drop', className)
  }, {
    children: jsxs("ul", Object.assign({
      className: "cds-global-header__sub-list"
    }, {
      children: [shouldBeRendered(subMenuLabel, [isMobileView]) && jsx("li", Object.assign({
        className: "cds-navigation__sub-item"
      }, {
        children: jsx(LinkElement, Object.assign({
          className: classNames('cds-navigation__sub-link', {
            active: activeUrlPath === href
          }),
          "aria-current": activeUrlPath === href,
          "aria-label": ariaLabel,
          onClick: handleMobileNavigationItemClick,
          href: href,
          variant: "nav",
          size: "large",
          onFocus: handleFocus,
          onBlur: handleBlur
        }, {
          children: subMenuLabel
        }))
      })), subItems.map(function (_a) {
        var subLabel = _a.label,
          subHref = _a.href,
          subAriaLabel = _a.ariaLabel,
          subItem = __rest$1(_a, ["label", "href", "ariaLabel"]);
        return jsx("li", {
          children: jsx(LinkElement, Object.assign({
            className: classNames('cds-global-header__sub-link', {
              active: activeUrlPath === subHref
            }),
            "aria-current": activeUrlPath === subHref
          }, subItem, {
            "aria-label": subAriaLabel,
            onClick: function onClick() {
              return handleClick(subLabel);
            },
            href: subHref,
            variant: "nav",
            size: getLinkSize(isMobileView),
            onFocus: handleFocus,
            onBlur: handleBlur
          }, {
            children: subLabel
          }))
        }, subLabel);
      })]
    }))
  }));
};
var NavigationItem = function NavigationItem(_ref11) {
  var className = _ref11.className,
    linkNavElement = _ref11.linkNavElement,
    activeUrlPath = _ref11.activeUrlPath,
    _ref11$href = _ref11.href,
    href = _ref11$href === void 0 ? '' : _ref11$href,
    ariaLabel = _ref11.ariaLabel,
    isMobileView = _ref11.isMobileView,
    label = _ref11.label,
    subItems = _ref11.subItems,
    subMenuLabel = _ref11.subMenuLabel,
    isJS = _ref11.isJS,
    openIcon = _ref11.openIcon,
    closeIcon = _ref11.closeIcon,
    expandTitle = _ref11.expandTitle,
    onClickNavItem = _ref11.onClickNavItem,
    handleMobileNavigationItemClick = _ref11.handleMobileNavigationItemClick;
  var LinkElement = linkNavElement || Link;
  var _useDropdown2 = useDropdown(),
    handleDesktopBlur = _useDropdown2.handleDesktopBlur,
    handleDesktopOutsideBlur = _useDropdown2.handleDesktopOutsideBlur,
    handleFocus = _useDropdown2.handleFocus,
    handleMenuItemClick = _useDropdown2.handleMenuItemClick,
    handleKeyPress = _useDropdown2.handleKeyPress,
    isOpen = _useDropdown2.isOpen,
    handleMouseOver = _useDropdown2.handleMouseOver;
  var onMouseOverDesktop = subItems && !isMobileView ? handleMouseOver : undefined;
  var handleClick = function handleClick(e) {
    if (onClickNavItem) onClickNavItem(label);
    handleMenuItemClick(e, Boolean(subItems === null || subItems === void 0 ? void 0 : subItems.length), handleMobileNavigationItemClick);
  };
  return jsxs("li", Object.assign({
    className: classNames('cds-global-header__navigation-item', className, {
      'cds-global-header__navigation-item--has-children': Boolean(subItems)
    }),
    onBlur: handleDesktopOutsideBlur,
    onMouseLeave: handleDesktopBlur
  }, {
    children: [jsx(LinkElement, Object.assign({
      className: classNames('cds-global-header__navigation-link', {
        active: isActive(activeUrlPath, href, subItems || []),
        'has-submenu': Boolean(subItems === null || subItems === void 0 ? void 0 : subItems.length)
      }),
      onClick: handleClick,
      "aria-current": activeUrlPath === href,
      onMouseOver: onMouseOverDesktop,
      href: href,
      variant: "nav",
      size: getLinkSize(isMobileView),
      "aria-label": ariaLabel
    }, {
      children: label
    })), shouldBeRendered(label, [isJS, Boolean(subItems)], 'and') ? jsx(Button, Object.assign({
      variant: "nav",
      onClick: handleClick,
      onKeyDown: handleKeyPress,
      onMouseOver: onMouseOverDesktop,
      size: getLinkSize(isMobileView),
      className: "cds-global-header__navigation-arrow",
      "aria-expanded": isOpen,
      iconSuffix: getLinkIcon(openIcon, closeIcon, isOpen)
    }, {
      children: "".concat(expandTitle, " ").concat(label)
    })) : null, shouldBeRendered(subItems, [isOpen], 'or') && jsx(SubNavigation, {
      subItems: subItems,
      activeUrlPath: activeUrlPath,
      subMenuLabel: subMenuLabel,
      linkNavElement: linkNavElement,
      handleFocus: handleFocus,
      handleBlur: handleDesktopBlur,
      isMobileView: isMobileView,
      href: href,
      ariaLabel: ariaLabel,
      handleMobileNavigationItemClick: handleMobileNavigationItemClick,
      onClickSubnavItem: onClickNavItem
    })]
  }));
};
var Profile = function Profile(_ref12) {
  var headline = _ref12.headline,
    greeting = _ref12.greeting,
    icon = _ref12.icon.icon,
    account = _ref12.account,
    orders = _ref12.orders,
    savedProducts = _ref12.savedProducts,
    register = _ref12.register,
    logIn = _ref12.logIn,
    logOut = _ref12.logOut,
    isSignedIn = _ref12.isSignedIn,
    handleSignOut = _ref12.handleSignOut,
    handleLogIn = _ref12.handleLogIn,
    handleRegister = _ref12.handleRegister,
    userName = _ref12.userName,
    _ref12$linkNavElement = _ref12.linkNavElement,
    LinkElement = _ref12$linkNavElement === void 0 ? Link : _ref12$linkNavElement,
    isMobileView = _ref12.isMobileView;
  return jsx("div", Object.assign({
    className: "cds-global-header-profile"
  }, {
    children: isSignedIn ? jsxs(Fragment, {
      children: [jsx(Typography, {
        className: "cds-global-header-profile__greeting",
        variant: "body",
        weight: "medium",
        size: "m",
        tag: "p",
        content: "".concat(greeting).concat(userName !== null && userName !== void 0 ? userName : '', " \uD83D\uDC4B")
      }), jsx(LinkElement, Object.assign({
        className: "cds-global-header-profile__link"
      }, orders)), jsx(LinkElement, Object.assign({
        className: "cds-global-header-profile__link"
      }, savedProducts)), jsx(LinkElement, Object.assign({
        className: "cds-global-header-profile__link"
      }, account)), jsx(Button, Object.assign({
        className: "cds-global-header-profile__button cds-global-header-profile__button--log-out"
      }, logOut, {
        variant: isMobileView ? 'primary' : 'secondary',
        onClick: handleSignOut
      }))]
    }) : jsxs(Fragment, {
      children: [jsxs("div", Object.assign({
        className: "cds-global-header-profile__headline-wrapper"
      }, {
        children: [isMobileView ? jsx(Icon, {
          className: "cds-global-header-profile__headline-icon",
          icon: icon
        }) : null, jsx(Typography, {
          className: "cds-global-header-profile__headline",
          variant: "body",
          weight: "medium",
          size: "m",
          tag: "p",
          content: headline
        })]
      })), jsxs("div", Object.assign({
        className: "cds-global-header-profile__buttons-wrapper"
      }, {
        children: [jsx(Button, Object.assign({
          className: "cds-global-header-profile__button cds-global-header-profile__button--register"
        }, register, {
          onClick: handleRegister
        })), jsx(Button, Object.assign({
          className: "cds-global-header-profile__button cds-global-header-profile__button--log-in"
        }, logIn, {
          onClick: handleLogIn
        }))]
      }))]
    })
  }));
};
var Navigation = function Navigation(_ref13) {
  var navigationName = _ref13.navigationName,
    navigationData = _ref13.navigationData,
    linkNavElement = _ref13.linkNavElement,
    onClickNavItem = _ref13.onClickNavItem,
    className = _ref13.className,
    closeIcon = _ref13.closeIcon,
    openIcon = _ref13.openIcon,
    activeUrlPath = _ref13.activeUrlPath,
    logo = _ref13.logo,
    moreBtn = _ref13.moreBtn,
    handleMobileNavigationItemClick = _ref13.handleMobileNavigationItemClick,
    languageSwitch = _ref13.languageSwitch,
    search = _ref13.search,
    cartIcon = _ref13.cartIcon,
    profile = _ref13.profile;
  var listRef = useRef(null);
  var navRef = useRef(null);
  var _useBrowserScreen3 = useBrowserScreen(),
    isMobileView = _useBrowserScreen3.isMobileView;
  var _useJS = useJS(),
    _useJS2 = _slicedToArray(_useJS, 1),
    isJS = _useJS2[0];
  var _useNavigationResize = useNavigationResize({
      navigationData: navigationData,
      listRef: listRef,
      navRef: navRef
    }),
    visibleItems = _useNavigationResize.visibleItems,
    hiddenItems = _useNavigationResize.hiddenItems;
  return jsx("nav", Object.assign({
    ref: navRef,
    className: classNames('cds-global-header__navigation', className),
    "aria-label": navigationName
  }, {
    children: jsxs("ul", Object.assign({
      ref: listRef,
      className: "cds-global-header__navigation-list"
    }, {
      children: [logo && jsx("li", Object.assign({
        className: "cds-global-header__navigation-logo"
      }, {
        children: jsx(Logo, {
          className: "cds-global-header__desktop-logo",
          image: logo.imageLarge,
          link: logo.link
        })
      })), visibleItems.map(function (item) {
        return jsx(NavigationItem, Object.assign({
          linkNavElement: linkNavElement,
          activeUrlPath: activeUrlPath,
          isMobileView: isMobileView,
          openIcon: openIcon,
          closeIcon: closeIcon,
          expandTitle: moreBtn.title,
          isJS: isJS,
          onClickNavItem: onClickNavItem,
          handleMobileNavigationItemClick: handleMobileNavigationItemClick
        }, item), item.label);
      }), shouldBeRendered(moreBtn, [isJS, !isMobileView, (hiddenItems === null || hiddenItems === void 0 ? void 0 : hiddenItems.length) > 0], 'and') ? jsx(NavigationItem, {
        className: classNames(moreClassName, _defineProperty2({}, "".concat(moreClassName, "--hidden"), !navigationData.length)),
        linkNavElement: linkNavElement,
        activeUrlPath: activeUrlPath,
        isMobileView: isMobileView,
        openIcon: openIcon,
        closeIcon: closeIcon,
        expandTitle: moreBtn.title,
        subItems: hiddenItems,
        ariaLabel: moreBtn === null || moreBtn === void 0 ? void 0 : moreBtn.ariaLabel,
        handleMobileNavigationItemClick: handleMobileNavigationItemClick,
        isJS: isJS,
        label: moreBtn.title,
        onClickNavItem: onClickNavItem,
        href: "/#more"
      }) : null, languageSwitch ? jsx(LanguageSwitch, Object.assign({
        linkNavElement: linkNavElement,
        openIcon: openIcon,
        closeIcon: closeIcon,
        isMobileView: isMobileView
      }, languageSwitch)) : null, search && !isMobileView ? jsx("li", Object.assign({
        className: "cds-global-header__navigation-search\n                        cds-global-header__navigation-icon"
      }, {
        children: jsx(SearchBlock, Object.assign({}, search, {
          handleBurgerMenu: handleMobileNavigationItemClick
        }))
      })) : null, cartIcon && !isMobileView ? jsx("li", Object.assign({
        className: classNames(cartIconClassName, 'cds-global-header__navigation-icon')
      }, {
        children: jsx(CartIcon, Object.assign({}, cartIcon))
      })) : null, profile ? jsx("li", Object.assign({
        className: classNames(profileClassName, {
          'cds-global-header__navigation-icon': !isMobileView
        })
      }, {
        children: !isMobileView ? jsx(Tooltip, {
          tooltipWindowClassName: "cds-global-header-profile-window",
          portalQuerySelector: ".cds-tooltip",
          label: profile.headline,
          isTooltipContentInteractive: true,
          icon: "profile",
          content: jsx(Profile, Object.assign({}, profile))
        }) : jsx(Profile, Object.assign({}, profile, {
          isMobileView: isMobileView
        }))
      })) : null]
    }))
  }));
};
var SkipLink = function SkipLink(_a) {
  var children = _a.children,
    mode = _a.mode,
    linkProps = __rest$1(_a, ["children", "mode"]);
  return jsx(Section, Object.assign({
    element: "div",
    mode: mode,
    className: "cds-skip-link"
  }, {
    children: jsx(Link, Object.assign({
      className: "cds-skip-link__link"
    }, linkProps, {
      children: children
    }))
  }));
};
var UtilityLinks = function UtilityLinks(_ref14) {
  var _ref14$linkNavElement = _ref14.linkNavElement,
    LinkElement = _ref14$linkNavElement === void 0 ? Link : _ref14$linkNavElement,
    _ref14$utilityLinksDa = _ref14.utilityLinksData,
    utilityLinksData = _ref14$utilityLinksDa === void 0 ? [] : _ref14$utilityLinksDa,
    utilityLinksName = _ref14.utilityLinksName;
  return jsx("nav", Object.assign({
    "aria-label": utilityLinksName,
    className: "cds-utility-navigation"
  }, {
    children: jsx("ul", Object.assign({
      className: "cds-utility-navigation__list"
    }, {
      children: utilityLinksData.map(function (_a) {
        var href = _a.href,
          label = _a.label,
          ariaLabel = _a.ariaLabel,
          rest = __rest$1(_a, ["href", "label", "ariaLabel"]);
        return jsx("li", Object.assign({
          className: "cds-utility-navigation__item"
        }, {
          children: jsx(LinkElement, Object.assign({
            className: "cds-utility-navigation__link",
            href: href,
            variant: "subtle",
            size: "small",
            "aria-label": ariaLabel
          }, rest, {
            children: label
          }))
        }), label);
      })
    }))
  }));
};
var useBurgerMenu = function useBurgerMenu(headerReference) {
  var DOCUMENT_LOCK_CLASSNAME = 'cds-scroll-locked';
  var _useBrowserScreen4 = useBrowserScreen(),
    isMobileView = _useBrowserScreen4.isMobileView;
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    isOpen = _useState20[0],
    setIsOpen = _useState20[1];
  var _useState21 = useState(0),
    _useState22 = _slicedToArray(_useState21, 2),
    burgerOffsetTop = _useState22[0],
    setBurgerOffsetTop = _useState22[1];
  var burgerBtnRef = useRef(null);
  var handleBurgerClick = function handleBurgerClick(e) {
    e.preventDefault();
    var headerEl = headerReference.current;
    if (headerEl) {
      setBurgerOffsetTop(headerEl.getBoundingClientRect().top + headerEl.offsetHeight);
    }
    setIsOpen(!isOpen);
  };
  var handleMobileNavigationItemClick = function handleMobileNavigationItemClick() {
    setIsOpen(!isOpen);
  };
  var handleMobileLogoClick = function handleMobileLogoClick() {
    setIsOpen(false);
  };
  var handler = useCallback(function () {
    if (!isMobileView) {
      setIsOpen(false);
    }
  }, [isMobileView]);
  useEffect(function () {
    setIsOpen(false);
  }, []);
  useEffect(function () {
    if (isOpen) {
      document.documentElement.classList.add(DOCUMENT_LOCK_CLASSNAME);
    } else {
      document.documentElement.classList.remove(DOCUMENT_LOCK_CLASSNAME);
    }
    if (burgerBtnRef.current) {
      burgerBtnRef.current.focus();
    }
  }, [isOpen]);
  useEffect(function () {
    window.addEventListener('resize', handler);
    window.addEventListener('orientationchange', handler);
    return function () {
      window.removeEventListener('resize', handler);
      window.removeEventListener('orientationchange', handler);
    };
  }, [handler]);
  return {
    isOpen: isOpen,
    burgerBtnRef: burgerBtnRef,
    handleBurgerClick: handleBurgerClick,
    burgerOffsetTop: burgerOffsetTop,
    handleMobileNavigationItemClick: handleMobileNavigationItemClick,
    handleMobileLogoClick: handleMobileLogoClick
  };
};
var useStickyObserver = function useStickyObserver(reference, callback) {
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    isSticky = _useState24[0],
    setSticky = _useState24[1];
  useEffect(function () {
    var stickyElm = reference.current;
    if (stickyElm && window) {
      var observer = new IntersectionObserver(function (_ref15) {
        var _ref16 = _slicedToArray(_ref15, 1),
          e = _ref16[0];
        setSticky(e.intersectionRatio < 1);
        if (e.intersectionRatio === 1 && callback) {
          callback(stickyElm === null || stickyElm === void 0 ? void 0 : stickyElm.dataset.target);
        }
      }, {
        threshold: [1, 0]
      });
      observer.observe(stickyElm);
      return function () {
        observer.unobserve(stickyElm);
      };
    }
    return undefined;
  }, [reference, callback]);
  return [isSticky];
};
var GlobalHeader = function GlobalHeader(_ref17) {
  var _classNames3;
  var className = _ref17.className,
    logo = _ref17.logo,
    _ref17$isHeaderSticky = _ref17.isHeaderSticky,
    isHeaderSticky = _ref17$isHeaderSticky === void 0 ? false : _ref17$isHeaderSticky,
    skipLink = _ref17.skipLink,
    utilityLinksData = _ref17.utilityLinksData,
    utilityLinksName = _ref17.utilityLinksName,
    mode = _ref17.mode,
    linkNavElement = _ref17.linkNavElement,
    onClickNavItem = _ref17.onClickNavItem,
    burgerToggleLabel = _ref17.burgerToggleLabel,
    burgerOpenLabel = _ref17.burgerOpenLabel,
    burgerCloseLabel = _ref17.burgerCloseLabel,
    burgerOpenIcon = _ref17.burgerOpenIcon,
    burgerCloseIcon = _ref17.burgerCloseIcon,
    navigationName = _ref17.navigationName,
    navigationData = _ref17.navigationData,
    activeUrlPath = _ref17.activeUrlPath,
    moreBtn = _ref17.moreBtn,
    openIcon = _ref17.openIcon,
    closeIcon = _ref17.closeIcon,
    languageSwitch = _ref17.languageSwitch,
    search = _ref17.search,
    cartIcon = _ref17.cartIcon,
    profile = _ref17.profile,
    renderOnStart = _ref17.renderOnStart,
    renderOnEnd = _ref17.renderOnEnd,
    renderOnBurgerPopupStart = _ref17.renderOnBurgerPopupStart,
    renderOnBurgerPopupEnd = _ref17.renderOnBurgerPopupEnd,
    uid = _ref17.uid;
  var headerRef = useRef(null);
  var _useStickyObserver = useStickyObserver(headerRef),
    _useStickyObserver2 = _slicedToArray(_useStickyObserver, 1),
    isSticky = _useStickyObserver2[0];
  var _useJS3 = useJS(),
    _useJS4 = _slicedToArray(_useJS3, 1),
    isJS = _useJS4[0];
  var _useBurgerMenu = useBurgerMenu(headerRef),
    isOpen = _useBurgerMenu.isOpen,
    burgerBtnRef = _useBurgerMenu.burgerBtnRef,
    handleBurgerClick = _useBurgerMenu.handleBurgerClick,
    burgerOffsetTop = _useBurgerMenu.burgerOffsetTop,
    handleMobileNavigationItemClick = _useBurgerMenu.handleMobileNavigationItemClick,
    handleMobileLogoClick = _useBurgerMenu.handleMobileLogoClick;
  var _useBrowserScreen5 = useBrowserScreen(),
    isMobileView = _useBrowserScreen5.isMobileView;
  useEffect(function () {
    var htmlObject = document.getElementsByTagName('html')[0];
    if (isHeaderSticky) {
      htmlObject.classList.add('has-sticky-nav');
    } else {
      htmlObject.classList.remove('has-sticky-nav');
    }
  }, [isHeaderSticky]);
  return jsxs(Section, Object.assign({
    ref: headerRef,
    element: "header",
    id: "open-menu",
    mode: mode,
    removeDuplicateSpacing: false,
    "data-status": isJS ? 'js' : 'no-js',
    className: classNames('cds-global-header', className, (_classNames3 = {}, _defineProperty2(_classNames3, "cds-global-header--is-sticky", isSticky && isHeaderSticky), _defineProperty2(_classNames3, "cds-global-header--sticky-mode", isHeaderSticky), _defineProperty2(_classNames3, "cds-global-header--burger-opened", isMobileView && isOpen), _classNames3)),
    "data-component-uid": uid
  }, {
    children: [jsx(SkipLink, Object.assign({}, skipLink)), jsx(Container, Object.assign({
      maxWidth: "max-grid"
    }, {
      children: jsx(FocusTrapWrapper, Object.assign({
        isOpen: isOpen,
        isMobileView: isMobileView,
        isJS: isJS
      }, {
        children: jsxs("div", Object.assign({
          className: "header-portal"
        }, {
          children: [renderOnStart, jsxs("div", Object.assign({
            className: "cds-global-header__mobile-main"
          }, {
            children: [logo && jsx(Logo, {
              className: "cds-global-header__mobile-logo",
              image: logo.imageSmall,
              link: logo.link,
              onClick: handleMobileLogoClick
            }), isMobileView && jsxs("ul", Object.assign({
              className: "cds-global-header__navigation-wrapper"
            }, {
              children: [search ? jsx("li", Object.assign({
                className: classNames('cds-global-header__navigation-search', 'cds-global-header__navigation-icon')
              }, {
                children: jsx(SearchBlock, Object.assign({}, search, {
                  handleBurgerMenu: handleMobileNavigationItemClick
                }))
              })) : null, cartIcon ? jsx("li", Object.assign({
                className: classNames(cartIconClassName, 'cds-global-header__navigation-icon')
              }, {
                children: jsx(CartIcon, Object.assign({}, cartIcon))
              })) : null, jsx("li", {
                children: jsx(BurgerOpener, {
                  burgerToggleLabel: burgerToggleLabel,
                  burgerOpenIcon: burgerOpenIcon,
                  burgerCloseIcon: burgerCloseIcon,
                  burgerOpenLabel: burgerOpenLabel,
                  isJS: isJS,
                  handleBurgerClick: handleBurgerClick,
                  isOpen: isOpen,
                  burgerBtnRef: burgerBtnRef,
                  isMobileView: isMobileView
                })
              })]
            }))]
          })), isOpen || !isMobileView || !isJS ? jsxs("div", Object.assign({
            style: {
              top: "".concat(burgerOffsetTop, "px")
            },
            className: "cds-global-header__burger-popup"
          }, {
            children: [renderOnBurgerPopupStart, jsx(BurgerCloser, {
              burgerCloseIcon: burgerCloseIcon,
              burgerCloseLabel: burgerCloseLabel,
              isJS: isJS
            }), shouldBeRendered(utilityLinksData, [!isJS, !isMobileView], 'or') && jsx("div", Object.assign({
              className: "cds-global-header__top"
            }, {
              children: jsx(UtilityLinks, {
                utilityLinksData: utilityLinksData,
                linkNavElement: linkNavElement,
                utilityLinksName: utilityLinksName
              })
            })), jsx("div", Object.assign({
              className: "cds-global-header__desktop-main"
            }, {
              children: jsx(Navigation, {
                navigationName: navigationName,
                navigationData: navigationData,
                activeUrlPath: activeUrlPath,
                linkNavElement: linkNavElement,
                handleMobileNavigationItemClick: handleMobileNavigationItemClick,
                logo: logo,
                moreBtn: moreBtn,
                openIcon: openIcon,
                closeIcon: closeIcon,
                languageSwitch: languageSwitch,
                search: search,
                cartIcon: cartIcon,
                onClickNavItem: onClickNavItem,
                profile: profile
              })
            })), shouldBeRendered(utilityLinksData, [isJS, isMobileView], 'and') && jsx("div", Object.assign({
              className: "cds-global-header__bottom"
            }, {
              children: jsx(UtilityLinks, {
                utilityLinksData: utilityLinksData,
                linkNavElement: linkNavElement,
                utilityLinksName: utilityLinksName
              })
            })), renderOnBurgerPopupEnd]
          })) : null, renderOnEnd]
        }))
      }))
    }))]
  }));
};
export { GlobalHeader };